import { ArrowRightIcon } from '@nx/fire/assets'
import { FireLink } from '@nx/fire/link'
import VisuallyHidden from '@nx/fire/visually-hidden'

import { StyledViewProfileLink } from './FirePersonCard.styles'
import { FirePersonCardProps } from './FirePersonCard.types'

export const ProfileLink = ({
  personUrl,
  isAlwaysCompact,
  name,
}: Required<
  Pick<FirePersonCardProps, 'personUrl' | 'name' | 'isAlwaysCompact'>
>) => (
  <FireLink href={personUrl}>
    <StyledViewProfileLink
      as="span"
      $level="S"
      $isAlwaysCompact={isAlwaysCompact}
    >
      View profile<VisuallyHidden> of {name}</VisuallyHidden>
      <ArrowRightIcon width={15} height={15} />
    </StyledViewProfileLink>
  </FireLink>
)
